import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function VerifyEmail() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token");
    const tenantId = params.get("tenant_id");

    useEffect(() => {
        if (!token) { navigate("/login"); return; }
        const url = tenantId 
            ? `/auth/verify-email/${token}?tenant_id=${tenantId}` 
            : `/auth/verify-email/${token}`;
        api.get(url)
            .then(() => { toast.success("Email verified!"); navigate("/dashboard"); })
            .catch(() => { toast.error("Invalid or expired link"); navigate("/login"); });
    }, [token, tenantId, navigate]);

    return (
        <div className="min-h-screen grid place-items-center bg-background">
            <Loader2 className="w-8 h-8 animate-spin text-primary" />
        </div>
    );
}
